import React from 'react'
import { css } from '@emotion/core'
import HeadTitle from 'src/components/atoms/HeadTitle'
import { BreakPoint } from 'src/components/shared/CssValues'

const HeadLine = ({ children }) => {
  return (
    <HeadTitle as="h2" css={headTitleCss}>
      {children}
    </HeadTitle>
  )
}

const headTitleCss = css`
  width: 50%;
  text-align: left;

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 100%;
  }
`

export default HeadLine
